import { Component, OnInit } from "@angular/core";
import { ControllerService } from "../shared/services/controller.service";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { HttpService } from "../shared/services/http.service";

@Component({
    selector: "app-send-reflections",
    templateUrl: "./send-reflections.component.html",
    styleUrls: ["./send-reflections.component.scss"],
    standalone: false
})
export class SendReflectionsComponent implements OnInit {
  page: any = null;
  dynamicForm!: UntypedFormGroup;

  errored = {}
  values = {}

  constructor(
    public controller: ControllerService,
    private formBuilder: UntypedFormBuilder,
    private httpService: HttpService
  ) {}

  ngOnInit() {
    this.dynamicForm = this.formBuilder.group({
      customInputs: new UntypedFormArray([]),
    });

    this.page = this.controller
      .getSectionComponents()
      .find(({ type }) => type == "page");
  }

  handleYesNoChange($event){
    this.values[$event.sendTo] = $event.value
    delete this.errored[$event.sendTo]
  }

  async onNext(){
    const inputs = this.page.elements.filter(({type}) => type == 'yes-no')
    this.errored = {}

    for( const input of inputs ){
      if( this.values[input.properties.sendTo] === undefined ){
        this.errored[input.properties.sendTo] = true
      }
    }

    if( Object.entries(this.errored).length >0 ){
      return
    }

    const feedback = await this.controller.getTempData("feedback", [])

    const updatedFeedback = Object.entries(this.values).reduce(( acc, [key, value]) => {
      return acc.concat([{question: 'Send reflection to ' + key, answer: value ? 'yes' : 'no'}])
    }, feedback )

    await this.controller.storeTempData("feedback", updatedFeedback)

    // consented to sending email or sharing with hemisphere
    if( Object.values(this.values).filter(Boolean).length ){
      const templateId = this.controller.getSectionProperties().sendgridTemplateId
      const reflections = this.controller.getReflections()
      const code = this.controller.getActivationCode()

      try{
        const resp: any = await this.httpService.postAsync("actions/sendReflections", {
          templateId,
          reflections,
          code,
          values: this.values,
          contentId: this.controller.getContentId(),
        })
        if( resp && resp.success ){
          this.controller.setErrorMessage("")
        }
      }catch(e){
        this.controller.setErrorMessage("Error sending reflections, please wait a moment and try again.")
        return;
      }

    }

    await this.controller.next()

  }
}
